import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';

const DatePickerRangeComp = ({
        startDate,
        endDate,
        onStartDateChange,
        onEndDateChange,
        onStartDateClear,
        onEndDateClear,
        clearable = true,
        width = 160
 }) => {

    const today = dayjs();
    const nextDay = today.add(1, "day");

    const shouldDisableStartDate = (date) => {
        return date?.isAfter(nextDay);
    };

    const shouldDisableEndDate = (date) => {
        let conditionToDisable = startDate
            ? date?.isBefore(startDate)
            : date?.isBefore(today);

        return date?.isAfter(nextDay) || conditionToDisable;
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <h4 style={{ margin: 0, fontFamily: 'Manrope' }}>
                    От:
                </h4>

                <DesktopDatePicker
                    value={startDate}
                    onChange={onStartDateChange}
                    yearsPerRow={4}
                    closeOnSelect
                    mask="__.__.____"
                    format="DD/MM/YYYY"
                    shouldDisableDate={shouldDisableStartDate}
                    sx={{
                        width: width,
                        '& .MuiInputBase-input': {
                            textAlign:'left'
                        },
                    }}
                    slotProps={{
                        field: {
                            clearable: clearable,
                            onClear: onStartDateClear
                        },
                        textField: {
                            variant: 'standard',
                            placeholder: dayjs().format('DD/MM/YYYY'),
                            inputProps: {
                                disabled: true,
                                sx: { textAlign: 'center' }
                            },
                        },
                    }}
                />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <h4 style={{ margin: 0, marginLeft: 20, fontFamily: 'Manrope' }}>
                    До:
                </h4>

                <DesktopDatePicker
                    value={endDate}
                    onChange={onEndDateChange}
                    yearsPerRow={4}
                    closeOnSelect
                    mask="__.__.____"
                    format="DD/MM/YYYY"
                    disabled={!startDate}
                    maxDate={startDate ? dayjs(startDate).add(30, 'days') : null}
                    shouldDisableDate={shouldDisableEndDate}
                    sx={{
                        width: width,
                        '& .MuiInputBase-input': {
                            textAlign:'left'
                        },
                    }}
                    slotProps={{
                        field: {
                            clearable: clearable,
                            onClear: onEndDateClear
                        },
                        textField: {
                            variant: 'standard',
                            placeholder: null,
                            inputProps: {
                                disabled: true,
                                sx: { textAlign: 'center' }
                            },
                        },
                    }}
                />
            </LocalizationProvider>

        </div>
    );
};

export default DatePickerRangeComp;